export default __webpack_public_path__ + "static/media/edit.bc8bf00e.svg";